export enum ProcessType {
    client = 'client',
    server = 'server'
}
